import * as i0 from "@angular/core";
export class VersionService {
    constructor() {
        this.versionNumber = "v20230609";
    }
}
VersionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VersionService_Factory() { return new VersionService(); }, token: VersionService, providedIn: "root" });
